import { IOneMessageJson } from "../../../../../../nodeserver/structs/database.js";
import JSX from "./../../../helpers/react.js";
import RefObject = JSX.RefObject;
import { disappearingElement, rotate90deg, rotateBack, } from "../../../messages/helpers.js";
import { hideUserMessageActionsDetailsPassElement, showUserMessageActionsDetailsPassElement } from "../user-actions.js";


export function HumburgerActionElement(props: {
    msg: IOneMessageJson,
    message: RefObject<HTMLDivElement>
}){
    const humburgerElement = !props.msg.deleted ? (
        <div className="message-actions-humburger message-action-padding action-element"
            onClick={(e) => userMessageActionHumburgerClickHandler(e, props.message.value!)}
        >
            <img src="/img/message-actions-humburger.svg" className="action-element-img message-actions-humburger-img"/>
        </div>
    ) : <></>;

    return humburgerElement;
}


export function userMessageActionHumburgerClickHandler(
    event: MouseEvent & {
        target: HTMLElement
    },
    message: HTMLDivElement
) {

    let userActionsDetailsElement = $(message).find(".user-message-actions-details");

    if (userActionsDetailsElement[0].classList.contains(disappearingElement))
        showUserMessageActionsDetailsPassElement(userActionsDetailsElement, message);
    else
        hideUserMessageActionsDetailsPassElement(userActionsDetailsElement, message!);
}

export function setDefaultHumburgerPosition(message: HTMLDivElement){
    let humburgerElement = $(message).find(".message-actions-humburger .action-element-img")
    humburgerElement.removeClass(rotate90deg).addClass(rotateBack);
}


export function rotateHumburger(message: HTMLDivElement){
    let humburgerElement = $(message).find(".message-actions-humburger .action-element-img");

    humburgerElement.addClass(rotate90deg).removeClass(rotateBack);
}